import { BaseProduct } from '@telialt/models/src/EshopModel';
import { useSegment } from '@telialt/utils/src/segment';

import { baseProductFilteringParams } from '../../constants';
import { ESHOP_QUERY_KEY } from '../../model';
import { apiGetProduct, Params } from '../../store/api';
import { useCancelableQuery } from './useCancelableQuery';

interface UseBaseProductQueryI {
    baseProduct: BaseProduct;
    baseProductIsLoading: boolean;
    baseProductError: unknown;
}

/**
 * @deprecated This hook does not include all dependencies into query key and is not safe for extensive use
 * as old cached result can be returned if called multiple times with different `baseProductCode`.
 * Apps using this hook relies on query with key `ESHOP_QUERY_KEY.BASE_PRODUCT` without any parameter,
 * so refactoring this hook also requires major changes in those apps
 * Task for refactoring: LTDAT-16758
 * Use `useBaseProductQuery` instead
 */
export const useBaseProductQueryOld = (baseProductCode: string, params?: Params): UseBaseProductQueryI => {
    const segment = useSegment();

    const { data, isLoading, error } = useCancelableQuery(
        () => apiGetProduct<BaseProduct>(segment, baseProductCode, { ...baseProductFilteringParams, ...params }),
        { staleTime: 3000, queryKey: [ESHOP_QUERY_KEY.BASE_PRODUCT] },
    );

    return {
        baseProduct: data,
        baseProductIsLoading: isLoading,
        baseProductError: error,
    };
};
